module.exports = __webpack_public_path__ + "img/Ernesto_Figueredo.be4eb317.jpg";